"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_calendar_1 = __importDefault(require("react-calendar"));
const react_query_1 = require("@tanstack/react-query");
const dayjs_1 = __importDefault(require("dayjs"));
const bookingSlice_1 = require("../../../store/slices/bookingSlice");
const SpinnerOverlay_1 = __importDefault(require("../../../components/SpinnerOverlay/SpinnerOverlay"));
const store_1 = require("../../../store/store");
const lodash_1 = require("lodash");
const axios_1 = __importDefault(require("axios"));
const DateSelector = ({ appointment, bookingFlowType, }) => {
    var _a;
    const { calendarId, donationType } = (0, store_1.useAppSelector)((state) => state.booking.currentBooking);
    const userCanMakeAppointment = (0, store_1.useAppSelector)((state) => (0, bookingSlice_1.canUserMakeAppointment)(state));
    const { selectedDate, currentCalendarYear, currentCalendarMonth } = (0, store_1.useAppSelector)((state) => state.booking.currentBooking.date);
    const appSettings = (0, store_1.useAppSelector)((state) => state.app.appSettings);
    const dispatch = (0, store_1.useAppDispatch)();
    const { data: dates, isFetching } = (0, react_query_1.useQuery)({
        queryKey: [
            'bookable-dates',
            calendarId,
            currentCalendarYear,
            currentCalendarMonth,
            donationType,
        ],
        queryFn: () => axios_1.default
            .post('/api/booking/get-bookable-dates', {
            calendarId,
            fromDate: (0, dayjs_1.default)(`${currentCalendarYear}-${currentCalendarMonth + 1}`)
                .startOf('month')
                .format('YYYY-MM-DD'),
            toDate: (0, dayjs_1.default)(`${currentCalendarYear}-${currentCalendarMonth + 1}`)
                .endOf('month')
                .format('YYYY-MM-DD'),
            donationType,
            existingAppointmentId: bookingFlowType === 'rebook' ? appointment === null || appointment === void 0 ? void 0 : appointment.appointmentId : undefined,
        })
            .then((res) => res.data.data)
            .catch((err) => console.error('err', err)),
        enabled: !!calendarId && !!donationType,
    });
    const onDateChange = (value) => {
        dispatch((0, bookingSlice_1.setSelectedDate)(value));
        dispatch((0, bookingSlice_1.setStepIndex)(1));
    };
    const tileDisabled = ({ date, view }) => {
        if (dates && dates.length > 0 && view === 'month') {
            return dates.indexOf((0, dayjs_1.default)(date).format('YYYY-MM-DD')) === -1;
        }
        return true;
    };
    const types = (0, lodash_1.omit)(userCanMakeAppointment, ['allowed']);
    const daysToBookable = ((_a = (0, lodash_1.flatMap)(types).find((d) => d.donationType === donationType)) === null || _a === void 0 ? void 0 : _a.daysToBookable) || 0;
    const initialActiveStartDate = (0, react_1.useMemo)(() => {
        if (selectedDate) {
            return new Date(selectedDate);
        }
        return bookingFlowType === 'rebook' ? new Date() : (0, dayjs_1.default)().add(daysToBookable, 'day').toDate();
    }, [bookingFlowType, daysToBookable, selectedDate]);
    const onActiveStartDateChange = (0, react_1.useCallback)(({ activeStartDate, view }) => {
        const dt = selectedDate ? new Date(selectedDate) : undefined;
        if (!activeStartDate)
            return;
        if (view === 'month' &&
            (activeStartDate.getMonth() !== (dt === null || dt === void 0 ? void 0 : dt.getMonth()) ||
                activeStartDate.getFullYear() !== dt.getFullYear())) {
            dispatch((0, bookingSlice_1.setCurrentCalendarYear)(activeStartDate.getFullYear()));
            dispatch((0, bookingSlice_1.setCurrentCalendarMonth)(activeStartDate.getMonth()));
        }
    }, [dispatch, selectedDate]);
    (0, react_1.useEffect)(() => {
        onActiveStartDateChange({ activeStartDate: initialActiveStartDate, view: 'month' });
    }, [initialActiveStartDate, onActiveStartDateChange]);
    return (calendarId && ((0, jsx_runtime_1.jsx)("div", { className: "d-flex justify-content-center position-relative", children: (0, jsx_runtime_1.jsx)(SpinnerOverlay_1.default, { visible: isFetching, children: (0, jsx_runtime_1.jsx)(react_calendar_1.default, { onChange: onDateChange, defaultActiveStartDate: initialActiveStartDate, value: selectedDate ? new Date(selectedDate) : null, locale: (appSettings === null || appSettings === void 0 ? void 0 : appSettings.locale) || 'en', minDate: new Date(), onActiveStartDateChange: onActiveStartDateChange, tileDisabled: tileDisabled, view: "month" }) }) })));
};
exports.default = DateSelector;
